import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import LaddaButton from "../buttons/laddaButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { icons } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import "./styles.css";
import {
  changeDirectorGestionBtnState,
  changeManagementHeaderBtnState,
  changeMarketingPromotionManagementBtnState,
  changeWalletBtnState
} from "../../redux/slices/navigationSlice";
import { timeFrameState } from "../../constants/enums";
import { getCookie } from "../../utils/getCookie";
import {
  callApiAsync,
  getAuthorityByUser,
  getCallCurrentUser,
  getCallTimeFrameState,
  postCreateDashboard,
  postUpdateTimeFrameState
} from "../../services/apiService";
import {
  hasAnyRoleUtil,
  isRoleUtil
} from "../../utils/AuthorizedUtils/360Report";
import { usePageChangeEffect } from "../../utils/utilsFunctions";
import { useMediaQuery } from "@mui/material";
import { useCallback } from "react";
import { setUserData } from "../../redux/slices/userDataSlice";
import {
  SERALOGIN_ONLINE_ACCESS,
  canManageWalletProducts
} from "../../constants/walletRoles";
import { TASK_ROLES } from "../../constants/taskManagerRoles";
import {
  clearSessionAndRedirect,
  isInactiveSessionError
} from "../../utils/sessionGuard";
import {
  syncHeaderButtonStates,
  isNoButtonsRoute,
  isFullButtonsRoute,
  isBasicButtonsRoute
} from "./headerUtils";
import { isMicrosoftLoginDisabled } from "../../auth/msalConfig";

const urlLogin = (process.env.REACT_APP_LOGIN_SERALOGIN_URL || "").trim();

const Header = () => {
  const userSesion = getCookie("sesion");
  const userId = userSesion?.id_usuario;
  const navigate = useNavigate();

  const [showMenu, setshowMenu] = useState(false);
  const [locationUrl, setlocationUrl] = useState(false);
  const [buttonMenu, setButtonMenu] = useState(false);
  const [frameTimeState, setFrameTimeState] = useState(0);
  const [currentUser, setCurrentUser] = useState(null);
  const [buttonDirectionGestionMenu, setButtonDirectionGestionMenu] =
    useState(false);
  const [accompanimentResume, setAccompanimentResume] = useState(false);

  const location = useLocation();
  const isSmallScreen = useMediaQuery("(max-width:590px)");
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.userData.userData);
  const isLegacySession = Boolean(
    userData?.legacyPending ||
      userSesion?.legacyPending ||
      userData?.authSource === "LEGACY" ||
      userSesion?.authSource === "LEGACY"
  );
  const showManagementBtn = useSelector(
    (state) => state.navigation.showManagementHeaderBtn
  );
  const showWalletBtn = useSelector((state) => state.navigation.showWalletBtn);
  const showDirectorHeaderGestionBtn = useSelector(
    (state) => state.navigation.showDirectorGestionBtn
  );
  const showMarketingPromotionManagementBtn = useSelector(
    (state) => state.navigation.showMarketingPromotionManagementBtn
  );

  const handleMenuBtn = () => {
    setshowMenu(!showMenu);
  };

  const clearLocalSession = () => {
    Cookies.remove("sesion");
    sessionStorage.clear();
  };

  const handleLogout = () => {
    clearLocalSession();
    if ((isMicrosoftLoginDisabled || isLegacySession) && urlLogin) {
      window.location.replace(urlLogin);
      return;
    }
    window.location.replace("/login_plus");
  };

  function responsiveHandler() {
    const anchoPantalla = window.innerWidth;
    if (anchoPantalla > 630) {
      setshowMenu(false);
    }
  }

  useEffect(() => {
    window.addEventListener("resize", responsiveHandler);
    responsiveHandler();

    return () => {
      window.removeEventListener("resize", responsiveHandler);
    };
  }, []);

  // ------------------------ SETTINGS ------------------------

  const getSurveyConfiguration = async () => {
    callApiAsync(getCallTimeFrameState, (data) => {
      setFrameTimeState(data.state);
    });
  };

  const updateTimeFrameState = async () => {
    callApiAsync(postUpdateTimeFrameState);
  };

  const createDashboard = async () => {
    if (!userId) {
      clearSessionAndRedirect(dispatch, navigate);
      return;
    }

    callApiAsync(
      () => postCreateDashboard({ userId: userId }),
      () => {
        navigate("/superior_rol_dashboard");
      }
    );
  };

  const getUserInfo = async () => {
    if (!userId) return;

    callApiAsync(
      () => getCallCurrentUser(userId),
      (data) => {
        setCurrentUser(data);
      }
    );
  };

  usePageChangeEffect(() => {
    setButtonDirectionGestionMenu(false);
    setAccompanimentResume(false);
  });

  const getAuthorityByUserFn = useCallback(async () => {
    if (!userId) return;

    try {
      const response = await getAuthorityByUser(userId, {
        legacy: isLegacySession
      });
      const data = response.data;
      const authorityList = data.authorityList || [];
      const pageList = data.pageList || [];
      const roleList = data.roleIds || [];
      dispatch(
        setUserData({
          id: userId,
          authorityList,
          pageList,
          roleList,
          authSource: userData?.authSource || userSesion?.authSource || "INTERNAL",
          state: userData?.state || userSesion?.state || null,
          legacyPending: Boolean(
            userData?.legacyPending || userSesion?.legacyPending
          )
        })
      );
    } catch (error) {
      if (isInactiveSessionError(error)) {
        clearSessionAndRedirect(dispatch, navigate);
      }
    }
  }, [
    dispatch,
    isLegacySession,
    navigate,
    userData?.authSource,
    userData?.legacyPending,
    userData?.state,
    userId,
    userSesion?.authSource,
    userSesion?.legacyPending,
    userSesion?.state
  ]);

  useEffect(() => {
    if (!userId) return;

    getAuthorityByUserFn();
    getSurveyConfiguration();
    updateTimeFrameState();
    getUserInfo();
  }, [getAuthorityByUserFn, userId]);

  // ------------------------ url watcher ------------------------

  useEffect(() => {
    const verifyUrl = () => {
      const pathActual = location.pathname;
      setlocationUrl(pathActual);
    };
    setButtonMenu(false);
    verifyUrl();
  }, [location]);

  // Sincronizar estados de botones según la ruta actual
  useEffect(() => {
    syncHeaderButtonStates(location.pathname, dispatch, {
      changeWalletBtnState,
      changeMarketingPromotionManagementBtnState,
      changeDirectorGestionBtnState,
      changeManagementHeaderBtnState
    });
  }, [location.pathname, dispatch]);

  var isAdminBanner = isRoleUtil("ADMIN_BANNER", userData.roleList);

  var isAccompanimentModuleAccess = isRoleUtil(
    "ACCOMPANIMENT_MODULE_ACCESS",
    userData.roleList
  );

  var isModule360Admin = isRoleUtil("MODULE_360_ADMIN", userData.roleList);
  var isHumanManagementAccess = isRoleUtil(
    "SERALOGIN_HUMAN_MANAGEMENT_ACCESS",
    userData.roleList
  );
  var isSeraloginOnlineAccess = isRoleUtil(
    SERALOGIN_ONLINE_ACCESS,
    userData.roleList
  );
  var hasTaskRole = hasAnyRoleUtil(TASK_ROLES, userData.roleList);
  const canManageWalletProductsCatalog = canManageWalletProducts(
    userData.roleList
  );
  var isAccompanimentModuleViewver = isRoleUtil(
    "ACCOMPANIMENT_VIEWER",
    userData.roleList
  );

  return (
    <>
      <header
        style={{
          display: "flex",
          alignItems: "initial",
          justifyContent: "space-between",
          padding: isFullButtonsRoute(locationUrl) ? "10px 25px" : "10px 0",
          height: "80px",
          maxWidth: "1100px",
          minWidth: "300px",
          width: "100%",
          margin: "auto"
        }}
      >
        {/* ------------------------ LOGO ------------------------ */}
        <div style={{ display: "flex" }}>
          <Link to="/">
            <img
              className="logo-icon"
              src="/images/logo.png"
              alt="logo"
              style={{ marginTop: "-7px" }}
            />
          </Link>
          <div className="button_container">
            {showDirectorHeaderGestionBtn === true ? (
              <>
                <LaddaButton
                  width={
                    (currentUser?.cargo?.length ?? 0) > 10 ? "230px" : "190px"
                  }
                  fontSize={"13px"}
                  height={"32px"}
                  variant={
                    !buttonDirectionGestionMenu ? "contained" : "outlined"
                  }
                  backgroundColor={
                    !buttonDirectionGestionMenu ? "#6A6AD8" : "#FFFF"
                  }
                  color={!buttonDirectionGestionMenu ? "#FFFF" : "#6A6AD8"}
                  borderColor={"#6A6AD8"}
                  margin={"7px 5px 0 5px"}
                  onClick={() => {
                    setButtonDirectionGestionMenu(!buttonDirectionGestionMenu);
                  }}
                >
                  <p className="button_text">{"Gestión HSQ GCD"}</p>
                </LaddaButton>
                <div
                  className={` animated-div ${
                    buttonDirectionGestionMenu ? "visible" : ""
                  }`}
                >
                  <div className="VContainer">
                    <Link
                      to="/management_direction/banner_admin"
                      onClick={() => {
                        dispatch(changeManagementHeaderBtnState(false));
                        setButtonDirectionGestionMenu(false);
                      }}
                    >
                      <LaddaButton
                        width={
                          (currentUser?.cargo?.length ?? 0) > 10
                            ? "230px"
                            : "190px"
                        }
                        fontSize={"12px"}
                        height={"32px"}
                        variant="contained"
                        margin={"5px 5px"}
                      >
                        <p className="button_text">Administración Banner</p>
                      </LaddaButton>
                    </Link>
                    <Link
                      to="/gestion_HSQ_GCD/interestedParties"
                      onClick={() => {
                        dispatch(changeManagementHeaderBtnState(false));
                        setButtonDirectionGestionMenu(false);
                      }}
                    >
                      <LaddaButton
                        width={
                          (currentUser?.cargo?.length ?? 0) > 10
                            ? "230px"
                            : "190px"
                        }
                        fontSize={"12px"}
                        height={"32px"}
                        variant="contained"
                        margin={"5px 5px"}
                      >
                        <p className="button_text">Partes Interesadas</p>
                      </LaddaButton>
                    </Link>

                    <Link
                      to="/riskAndOpportunityManagement"
                      onClick={() => {
                        dispatch(changeManagementHeaderBtnState(false));
                        setButtonDirectionGestionMenu(false);
                      }}
                    >
                      <LaddaButton
                        width={
                          (currentUser?.cargo?.length ?? 0) > 10
                            ? "230px"
                            : "190px"
                        }
                        fontSize={"12px"}
                        height={"42px"}
                        variant="contained"
                        margin={"5px 5px"}
                      >
                        <p className="button_text">
                          Gestión de Riesgos y Oportunidades
                        </p>
                      </LaddaButton>
                    </Link>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>

          <div>
            {/* {isAdminBanner === false ? (
              <></>
            ) :  */}
            {isSmallScreen ? (
              <></>
            ) : showMarketingPromotionManagementBtn === true ? (
              <>
                <LaddaButton
                  width={"100%"}
                  fontSize={"13px"}
                  height={"32px"}
                  variant={!accompanimentResume ? "contained" : "outlined"}
                  backgroundColor={!accompanimentResume ? "#6A6AD8" : "#FFFF"}
                  color={!accompanimentResume ? "#FFFF" : "#6A6AD8"}
                  borderColor={"#6A6AD8"}
                  margin={"7px 5px 0 5px"}
                  onClick={() => {
                    setAccompanimentResume(!accompanimentResume);
                  }}
                >
                  <p className="button_text_mini">
                    {"Gestión Mercadeo y Promoción GMP"}
                  </p>
                </LaddaButton>
                <div
                  className={` animated-div ${
                    accompanimentResume ? "visible" : ""
                  }`}
                >
                  <div className="VContainer desplegable_menu_container">
                    <Link
                      to="/marketingPromotionManagement"
                      onClick={() => {
                        // dispatch(changeManagementHeaderBtnState(false));
                        setAccompanimentResume(false);
                      }}
                    >
                      <LaddaButton
                        width={"237px"}
                        fontSize={"12px"}
                        height={"32px"}
                        variant="contained"
                        margin={"3px 3px"}
                      >
                        <p className="button_text">Reporte Power BI</p>
                      </LaddaButton>
                    </Link>
                    {(isAccompanimentModuleAccess ||
                      isAccompanimentModuleViewver) && (
                      <Link
                        to="/marketingPromotionManagement/accompaniment_Module"
                        onClick={() => {
                          // dispatch(changeManagementHeaderBtnState(false));
                          setAccompanimentResume(false);
                        }}
                      >
                        <LaddaButton
                          width={"237px"}
                          fontSize={"12px"}
                          height={"32px"}
                          variant="contained"
                          margin={"3px 3px"}
                        >
                          <p className="button_text">
                            Módulo de Acompañamiento
                          </p>
                        </LaddaButton>
                      </Link>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
            {/**/}
          </div>

          {isSmallScreen ? (
            <></>
          ) : (
            <div>
              {showWalletBtn === true ? (
                <>
                  <LaddaButton
                    width={"100%"}
                    fontSize={"13px"}
                    height={"32px"}
                    variant={!accompanimentResume ? "contained" : "outlined"}
                    backgroundColor={!accompanimentResume ? "#6A6AD8" : "#FFFF"}
                    color={!accompanimentResume ? "#FFFF" : "#6A6AD8"}
                    borderColor={"#6A6AD8"}
                    margin={"7px 5px 0 5px"}
                    onClick={() => {
                      setAccompanimentResume(!accompanimentResume);
                    }}
                  >
                    <p className="button_text">
                      {"Gestión Financiera y Contable"}
                    </p>
                  </LaddaButton>
                  <div
                    className={` animated-div-mobile ${
                      accompanimentResume ? "visible" : ""
                    }`}
                  >
                    <div className="VContainer">
                      <Link
                        to="/wallet"
                        onClick={() => {
                          // dispatch(changeManagementHeaderBtnState(false));
                          setAccompanimentResume(false);
                        }}
                      >
                        <LaddaButton
                          width={"100%"}
                          fontSize={"12px"}
                          height={"32px"}
                          variant="contained"
                          margin={"5px 5px"}
                        >
                          <p className="button_text">Cartera SerAnest</p>
                        </LaddaButton>
                      </Link>
                      {canManageWalletProductsCatalog && (
                        <Link
                          to="/wallet/products"
                          onClick={() => {
                            // dispatch(changeManagementHeaderBtnState(false));
                            setAccompanimentResume(false);
                          }}
                        >
                          <LaddaButton
                            width={"100%"}
                            fontSize={"12px"}
                            height={"32px"}
                            variant="contained"
                            margin={"5px 5px"}
                          >
                            <p className="button_text">Productos cartera</p>
                          </LaddaButton>
                        </Link>
                      )}
                      <Link
                        to="/wallet/collection"
                        onClick={() => {
                          // dispatch(changeManagementHeaderBtnState(false));
                          setAccompanimentResume(false);
                        }}
                      >
                        <LaddaButton
                          width={"100%"}
                          fontSize={"12px"}
                          height={"32px"}
                          variant="contained"
                          margin={"5px 5px"}
                        >
                          <p className="button_text">Cartera por Factura</p>
                        </LaddaButton>
                      </Link>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          )}
        </div>

        {/* ------------------------ BTN CONTAINER ------------------------ */}
        <div className="button_container HContainer">
          {isNoButtonsRoute(locationUrl) ? (
            <></>
          ) : isFullButtonsRoute(locationUrl) ? (
            <>
              {showManagementBtn === false || !isHumanManagementAccess ? (
                <></>
              ) : (
                <div>
                  <LaddaButton
                    width={
                      (currentUser?.cargo?.length ?? 0) > 10 ? "140px" : "110px"
                    }
                    fontSize={"13px"}
                    height={"32px"}
                    variant={!buttonMenu ? "contained" : "outlined"}
                    backgroundColor={!buttonMenu ? "#6A6AD8" : "#FFFF"}
                    color={!buttonMenu ? "#FFFF" : "#6A6AD8"}
                    borderColor={"#6A6AD8"}
                    margin={"7px 5px 0 5px"}
                    onClick={() => setButtonMenu(!buttonMenu)}
                  >
                    <p className="button_text">{"Evaluación"}</p>
                  </LaddaButton>
                  <div
                    className={` animated-div ${buttonMenu ? "visible" : ""}`}
                  >
                    <div className="VContainer">
                      {frameTimeState == timeFrameState.ACTIVE && (
                        <Link
                          to="/self_appraisal"
                          onClick={() => {
                            dispatch(changeManagementHeaderBtnState(false));
                            dispatch(changeDirectorGestionBtnState(false));
                          }}
                        >
                          <LaddaButton
                            width={
                              (currentUser?.cargo?.length ?? 0) > 10
                                ? "140px"
                                : "110px"
                            }
                            fontSize={"12px"}
                            height={"32px"}
                            variant="contained"
                            margin={"5px 5px"}
                          >
                            <p className="button_text">Autoevaluación</p>
                          </LaddaButton>
                        </Link>
                      )}
                      {(frameTimeState == timeFrameState.INACTIVE ||
                        isModule360Admin) && (
                        <LaddaButton
                          onClick={() => createDashboard()}
                          width={
                            (currentUser?.cargo?.length ?? 0) > 10
                              ? "140px"
                              : "110px"
                          }
                          fontSize={"12px"}
                          height={"32px"}
                          variant="contained"
                          margin={"2px 5px"}
                        >
                          <p className="button_text">Dashboard</p>
                        </LaddaButton>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {isSeraloginOnlineAccess && (
                <Link to="/seralogin_online">
                  <LaddaButton
                    variant="contained"
                    height={"32px"}
                    margin={"7px 5px 0 5px"}
                  >
                    <p className="button_text">Seralogin Online</p>
                  </LaddaButton>
                </Link>
              )}
              {hasTaskRole && (
                <Link to="/manage_time">
                  <LaddaButton
                    variant="contained"
                    height={"32px"}
                    margin={"7px 5px 0 5px"}
                  >
                    <p className="button_text">Gestiona tu tiempo</p>
                  </LaddaButton>
                </Link>
              )}
              <LaddaButton
                variant="contained"
                height={"32px"}
                onClick={handleLogout}
              >
                <div className="HContainer align-center">
                  <img
                    className="btn-icon"
                    src={icons.logoutWhite}
                    alt="icon"
                    style={{ marginRight: "10px" }}
                  />
                  <p className="button_text">Salir</p>
                </div>
              </LaddaButton>
            </>
          ) : isBasicButtonsRoute(locationUrl) ? (
            <>
              <LaddaButton
                variant="contained"
                onClick={handleLogout}
              >
                <div className="HContainer align-center">
                  <img
                    className="btn-icon"
                    src={icons.logoutWhite}
                    alt="icon"
                    style={{ marginRight: "10px" }}
                  />
                  <p className="button_text">Salir</p>
                </div>
              </LaddaButton>
            </>
          ) : (
            <></>
          )}
        </div>
        {/* ------------------------ MENU BTN ------------------------ */}
        <div className="button_container_mobile">
          <LaddaButton
            variant="outlined"
            backgroundColor={"#ffff"}
            color={"#6A6AD8"}
            onClick={() => handleMenuBtn()}
          >
            <MenuIcon />
          </LaddaButton>
        </div>
      </header>
      {/* ------------------------ MOBILE MENU ------------------------ */}

      <div style={{ display: showMenu === false ? "none" : "block" }}>
        <div className="button_menu ">
          <div>
            {isAdminBanner === false ? (
              <></>
            ) : showDirectorHeaderGestionBtn === true ? (
              <>
                <LaddaButton
                  width={"100%"}
                  fontSize={"13px"}
                  height={"32px"}
                  variant={
                    !buttonDirectionGestionMenu ? "contained" : "outlined"
                  }
                  backgroundColor={
                    !buttonDirectionGestionMenu ? "#6A6AD8" : "#FFFF"
                  }
                  color={!buttonDirectionGestionMenu ? "#FFFF" : "#6A6AD8"}
                  borderColor={"#6A6AD8"}
                  margin={"7px 5px 0 5px"}
                  onClick={() => {
                    setButtonDirectionGestionMenu(!buttonDirectionGestionMenu);
                  }}
                >
                  <p className="button_text">{"Gestión de la Dirección"}</p>
                </LaddaButton>
                <div
                  className={` animated-div-mobile ${
                    buttonDirectionGestionMenu ? "visible" : ""
                  }`}
                >
                  <div className="VContainer">
                    <Link
                      to="/management_direction/banner_admin"
                      onClick={() => {
                        dispatch(changeManagementHeaderBtnState(false));
                        setButtonDirectionGestionMenu(false);
                      }}
                    >
                      <LaddaButton
                        width={"100%"}
                        fontSize={"12px"}
                        height={"32px"}
                        variant="contained"
                        margin={"5px 5px"}
                      >
                        <p className="button_text">Administración Banner</p>
                      </LaddaButton>
                    </Link>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>

          <div>
            {showWalletBtn === true ? (
              <>
                <LaddaButton
                  width={"100%"}
                  fontSize={"13px"}
                  height={"32px"}
                  variant={!accompanimentResume ? "contained" : "outlined"}
                  backgroundColor={!accompanimentResume ? "#6A6AD8" : "#FFFF"}
                  color={!accompanimentResume ? "#FFFF" : "#6A6AD8"}
                  borderColor={"#6A6AD8"}
                  margin={"7px 5px 0 5px"}
                  onClick={() => {
                    setAccompanimentResume(!accompanimentResume);
                  }}
                >
                  <p className="button_text">
                    {"Gestión Financiera y Contable"}
                  </p>
                </LaddaButton>
                <div
                  className={` animated-div-mobile ${
                    accompanimentResume ? "visible" : ""
                  }`}
                >
                  <div className="VContainer">
                    <Link
                      to="/wallet"
                      onClick={() => {
                        setAccompanimentResume(false);
                      }}
                    >
                      <LaddaButton
                        width={"100%"}
                        fontSize={"12px"}
                        height={"32px"}
                        variant="contained"
                        margin={"5px 5px"}
                      >
                        <p className="button_text">Cartera SerAnest</p>
                      </LaddaButton>
                    </Link>
                    {canManageWalletProductsCatalog && (
                      <Link
                        to="/wallet/products"
                        onClick={() => {
                          setAccompanimentResume(false);
                        }}
                      >
                        <LaddaButton
                          width={"100%"}
                          fontSize={"12px"}
                          height={"32px"}
                          variant="contained"
                          margin={"5px 5px"}
                        >
                          <p className="button_text">Productos cartera</p>
                        </LaddaButton>
                      </Link>
                    )}
                    <Link
                      to="/wallet/collection"
                      onClick={() => {
                        setAccompanimentResume(false);
                      }}
                    >
                      <LaddaButton
                        width={"100%"}
                        fontSize={"12px"}
                        height={"32px"}
                        variant="contained"
                        margin={"5px 5px"}
                      >
                        <p className="button_text">Cartera por Factura</p>
                      </LaddaButton>
                    </Link>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>

          <div>
            {/* {isAdminBanner === false ? (
              <></>
            ) : */}{" "}
            {showMarketingPromotionManagementBtn === true ? (
              <>
                <LaddaButton
                  width={"100%"}
                  fontSize={"13px"}
                  height={"32px"}
                  variant={!accompanimentResume ? "contained" : "outlined"}
                  backgroundColor={!accompanimentResume ? "#6A6AD8" : "#FFFF"}
                  color={!accompanimentResume ? "#FFFF" : "#6A6AD8"}
                  borderColor={"#6A6AD8"}
                  margin={"7px 5px 0 5px"}
                  onClick={() => {
                    setAccompanimentResume(!accompanimentResume);
                  }}
                >
                  <p className="button_text">
                    {"Gestión Mercadeo y Promoción GMP"}
                  </p>
                </LaddaButton>
                <div
                  className={` animated-div-mobile ${
                    accompanimentResume ? "visible" : ""
                  }`}
                >
                  <div className="VContainer">
                    <Link
                      to="/management_direction/banner_admin"
                      onClick={() => {
                        // dispatch(changeManagementHeaderBtnState(false));
                        setAccompanimentResume(false);
                      }}
                    >
                      <LaddaButton
                        width={"100%"}
                        fontSize={"12px"}
                        height={"32px"}
                        variant="contained"
                        margin={"5px 5px"}
                      >
                        <p className="button_text">Reporte Power BI</p>
                      </LaddaButton>
                    </Link>
                    {(isAccompanimentModuleAccess ||
                      isAccompanimentModuleViewver) && (
                      <Link
                        to="/marketingPromotionManagement/accompaniment_Module"
                        onClick={() => {
                          setAccompanimentResume(false);
                        }}
                      >
                        <LaddaButton
                          width={"100%"}
                          fontSize={"12px"}
                          height={"32px"}
                          variant="contained"
                          margin={"5px 5px"}
                        >
                          <p className="button_text">
                            Módulo de Acompañamiento
                          </p>
                        </LaddaButton>
                      </Link>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>

          {!isNoButtonsRoute(locationUrl) &&
            (isFullButtonsRoute(locationUrl) &&
            showManagementBtn &&
            isHumanManagementAccess ? (
              <div>
                <LaddaButton
                  width={"100%"}
                  fontSize={"13px"}
                  height={"32px"}
                  variant={!buttonMenu ? "contained" : "outlined"}
                  backgroundColor={!buttonMenu ? "#6A6AD8" : "#FFFF"}
                  color={!buttonMenu ? "#FFFF" : "#6A6AD8"}
                  borderColor={"#6A6AD8"}
                  margin={"7px 5px 0 5px"}
                  onClick={() => setButtonMenu(!buttonMenu)}
                >
                  <p className="button_text">{"Evaluación"}</p>
                </LaddaButton>
                <div
                  className={` animated-div-mobile  ${
                    buttonMenu ? "visible" : ""
                  }`}
                >
                  <div className="VContainer">
                    {frameTimeState == timeFrameState.ACTIVE && (
                      <Link
                        to="/self_appraisal"
                        onClick={() => {
                          dispatch(changeManagementHeaderBtnState(false));
                          dispatch(changeDirectorGestionBtnState(false));
                        }}
                      >
                        <LaddaButton
                          width={"100%"}
                          fontSize={"12px"}
                          height={"32px"}
                          variant="contained"
                          margin={"5px 5px"}
                        >
                          <p className="button_text">Autoevaluación</p>
                        </LaddaButton>
                      </Link>
                    )}
                    {(frameTimeState == timeFrameState.INACTIVE ||
                      isModule360Admin) && (
                      <LaddaButton
                        onClick={() => createDashboard()}
                        width={
                          (currentUser?.cargo?.length ?? 0) > 10
                            ? "140px"
                            : "110px"
                        }
                        fontSize={"12px"}
                        height={"32px"}
                        variant="contained"
                        margin={"2px 5px"}
                      >
                        <p className="button_text">Dashboard</p>
                      </LaddaButton>
                    )}
                  </div>
                </div>
              </div>
            ) : null)}

          {isFullButtonsRoute(locationUrl) && isSeraloginOnlineAccess && (
            <Link to="/seralogin_online">
              <LaddaButton
                variant="contained"
                height={"32px"}
                width={"100%"}
                margin={"5px 0"}
              >
                <p className="button_text">Seralogin Online</p>
              </LaddaButton>
            </Link>
          )}

          {isFullButtonsRoute(locationUrl) && hasTaskRole && (
            <Link to="/manage_time">
              <LaddaButton
                variant="contained"
                height={"32px"}
                width={"100%"}
                margin={"5px 0"}
              >
                <p className="button_text">Gestiona tu tiempo</p>
              </LaddaButton>
            </Link>
          )}

          <LaddaButton
            variant="contained"
            onClick={handleLogout}
            height={"32px"}
            width={"100%"}
          >
            <div className="align-center">
              <img
                className="btn-icon"
                src={icons.logoutWhite}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p className="button_text">Salir</p>
            </div>
          </LaddaButton>
        </div>
      </div>
    </>
  );
};

export default Header;
